import { CmsProtectionDetailsExclusions } from '../../models/protection-details/cms-protection-details-exclusions.interface';

export const mockCmsProtectionDetailsExclusions: CmsProtectionDetailsExclusions =
  {
    protectionDetailsExclusions: [{ item: '1' }, { item: '2' }, { item: '3' }],
  };
